import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export interface PersonalManagerMenu {
    isAssigned: boolean;
}

const personalManagerMenu = autoGeneratedReducer<PersonalManagerMenu>({ isAssigned: false });
export { personalManagerMenu };
